const backgroundImageMaxHeightInPx = 600;
const wrapper = "_35sws3mmgk";
const canvas = "_35sc19fthmm";
const inputs = "_35sin9w58m";
const contextMenu = "_35sc6k6qhs";
const background = "_35sbhumkjw";

export { background, backgroundImageMaxHeightInPx, canvas, contextMenu, inputs, wrapper };
import "./organism.canvas.style.linaria.module.css";
//# sourceMappingURL=organism.canvas.style.js.map
